export const getSetting = async (name: string): Promise<string | undefined> => {
  return window.cortiCodeAPI?.getSetting(name);
};

export const setSetting = async (name: string, value: any): Promise<void> => {
  return await window.cortiCodeAPI?.setSetting(name, value);
};
